const zhHK = {
  100000001:'關鍵信息',
  100000002:'幣種簡稱',
  100000003:'副本創建者',
  100000004:'副本建立時間',
  100000005:'基礎資訊',
  100000006:'所屬公鏈/協議',
  100000007:'智能合約地址',
  100000008:'發行時間',
  100000009:'發行總量',
  100000010:'流通總量',
  100000011:'市值',
  100000012:'簡介',
  100000013:'社媒資訊',
  100000014:'官網',
  100000015:'白皮書',
  100000016:'區塊鏈瀏覽器',
  100000017:'專案評分',
  100000018:'排名',
  100000019:'前',
  100000020:'代碼安全',
  100000021:'項目經營',
  100000022:'價格和流動性',
  100000023:'團隊治理',
  100000024:'項目成熟度',
  100000025:'社區和社媒',
  100000026:'更新時間',
  100000027:'安全評分',
  100000028:'合約安全評分',
  100000029:'風險項目統計',
  100000030:'合約代碼的明細',
  100000031:'購買稅',
  100000032:'賣出稅',
  100000033:'是否是蜜罐',
  100000034:'是否可再次 Mint',
  100000035:'是否有黑名单',
  100000036:'是否有白名单',
  100000037:'是否反鯨魚',
  100000038:'是否可更改稅率',
  100000039:'是否開源',
  100000040:'是否有隱藏的持有者',
  100000041:'是否可自毀',
  100000042:'是否是代理合约',
  100000043:'是否可以更改餘額',
  100000044:'是否可執行外部調用',
  100000045:'是否可重新獲取所有權',
  100000046:'是否有交易冷靜期',
  100000047:'是否可暫停轉賬',
  100000048:'所有權未放棄  ',
  100000049:'是否是可調整的反鯨魚  ',
  100000050:'小數位數過多  ',
  100000051:'公開的 Mint 和 Burn 方法  ',
  100000052:'燃燒代幣是否會更新總量  ',
  100000053:'燃燒代幣是否會更新餘額  ',
  100000054:'自轉帳是否會增加餘額  ',
  100000055:'轉出大於餘額的代幣是否會失效',
  100000056:'餘額在轉帳中未更新  ',
  100000057:'是否會消耗接收方餘額  ',
  100000058:'調用TransferFrom超過餘額時是否會失敗',
  100000059:'BurnFrom方法是否會更新總量',
  100000060:'檢測代幣的購買稅。5%以上被認為是高稅率',
  100000061:'檢測代幣的賣出稅。5%以上被認為是高稅率',
  100000062:'檢測代幣是否是蜜罐騙局',
  100000063:'檢查是否可以鑄造更多代幣',
  100000064:'檢查代幣是否有可以限制用戶交換或轉移代幣的黑名單',
  100000065:'檢查代幣是否具有允許地址繞過任何限制的白名單',
  100000066:'檢查代幣是否有反鯨魚機制',
  100000067:'檢查代幣是否有稅收，並且稅收可以由特權角色修改',
  100000068:'檢查代幣是否已在區塊鏈瀏覽器上驗證',
  100000069:'檢查代幣是否有可以操縱合約的隱藏所有者，即使所有權似乎已被放棄',
  100000070:'檢查代幣是否可以自毀',
  100000071:'檢查代幣是否是將函數調用委託給實現合約的代理合約',
  100000072:'檢查代幣餘額是否可以由特權角色修改',
  100000073:'檢查代幣是否調用外部合約',
  100000074:'檢查代幣是否有後門以重新獲得所有權',
  100000075:'檢查代幣是否有轉賬冷卻機制',
  100000076:'檢查特權角色是否可以暫停代幣交易',
  100000077:'檢查所有者權限是否已放棄',
  100000078:'檢查代幣的反鯨魚機制是否可以由特權角色修改',
  100000079:'檢查decimals()函數的返回值是否大於或等於5',
  100000080:'檢查隨機用戶調用mint()和burn()函數是否會回退',
  100000081:'檢查調用burn()函數是否會正確更新totalSupply',
  100000082:"檢查調用burnFrom()函數是否會正確更新津貼",
  100000083:'檢查與交易發起人相同的收件人調用transfer()函數是否會增加發起人的餘額',
  100000084:'檢查調用金額超過餘額的transfer()函數是否會失敗',
  100000085:"調用transferFrom()函數後檢查消費者的餘額是否有相應的更新",
  100000086:"檢查調用transferFrom()函數是否會使用消費者餘額",
  100000087:"检查调用 transferFrom() 后，允许额度是否正确更新，或者如果金额无效，交易是否会被回滚。",
  100000088:"检查调用 burnFrom() 函数是否会正确更新总量",
  100000089:'檢查是否存在造幣權',
  100000090:'檢查是否存在凍結權',
  100000091:'檢查元數據是否可以更改',
  100000092:'致命',
  100000093:'严重',
  100000094:'中度',
  100000095:'轻度',
  100000096:'仅需知',
  100000097:' mint權限是否已放棄',
  100000098:' 凍結權限是否已放棄',
  100000099:' 是否可以更改代幣的元數據',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default zhHK


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/zh-HK.js